<template>
  <div>
    <List
      url="getFileTechnologyPartners"
      deleteUrl="deleteFileTechnologyPartners"
      :tanle="tanle"
      :update="updateList"
      :afterList="dealGrade"
      :data="searchData"
      :isAdd="true"
      @add="add"
       @jump="jump"
      :operat="operat">
      <div slot="Filter">
        <el-input v-model="searchData.Key" placeholder="Company" style="width:400px;"></el-input>
        <el-button @click="updateList++" type="primary" style="margin-left:10px;">Search</el-button>
      </div>
    </List>
    <UpdateBox
      :updateType="updateType"
      :initForm="updateForm"
      v-if="updateBlock"
      @close="updateBlock = false"
      @update="updateList++"
    ></UpdateBox>
   
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/TechnologyPartners/UpdateBox.vue";
export default {
    components: {
        List,
        UpdateBox
       
    },
    data() {
        return {
            tanle: [
                { name: "Name", label: "Logo", type:"image"},
                { name: "Company", label: "Company", type:"word"}
            ],
            searchData: { Key: "" },
            updateList: 0,
            updateType: "add",
            updateForm: {},
            updateBlock: false,
            operat: [{
                text: "Delete",
                eventName: "delete",
                type: "danger",
                PretreatMethod: "confirmDelete"
            }]
        };
    },
    mounted() {},
    methods: {
        dealGrade (data) {
            for(let i in data) {
                data[i].Name = `${this.$http.host}akuvoxwiki/download/partnerManage/productMaterials/${data[i].Name}`;
            }
            return data;
        },
        add () {
            this.updateForm = {
                Company:"",
                Logo:""
            };
            this.updateType = "add";
            this.updateBlock = true;
        },
        jump(val) {
            this.$router.push(`/technologyPartnerUpdate?id=${val.ID}`);
        }
    },
    computed: {},
    watch:{}
};
</script>
